import { z } from 'zod';
import { query } from '../../utils';
export const hasClaimedQuest = query({
    method: 'GET',
    path: '/:questId/has-claimed',
    pathParams: z.object({
        questId: z.string().uuid(),
    }),
    responses: {
        200: z.object({
            hasClaimed: z.boolean(),
        }),
    },
});
